module.exports = __webpack_public_path__ + "static/media/bg_2.fd841e24.jpg";